<!--component html goes here -->
<!--component html goes here -->
<!-- Hero Start -->
<app-header></app-header>
  
<section class="bg-half-170 bg-light d-table w-100" style="background: url('assets/images/visa.jpg') center center;" id="home">
  <div class="bg-overlay"></div>
  <div class="container " >
      <div class="row mt-5 justify-content-center">
          <div class="col-lg-12 text-center">
              <div class="pages-heading">
                  <h4 class="title text-white title-dark mb-0"> Visa Details </h4>
              </div>
          </div> <!--end col-->
      </div><!--end row-->
      <div class="position-breadcrumb">
          <nav aria-label="breadcrumb" class="d-inline-block">
              <ul class="breadcrumb rounded shadow mb-0 px-4 py-2">
                  <li class="breadcrumb-item"><a routerLink="">Blimp</a></li>
                  <li class="breadcrumb-item"><a routerLink="/visas">Visaa</a></li>
                  <li class="breadcrumb-item"><a >Visaa Details</a></li>
              </ul>
          </nav>
      </div>
  </div> <!--end container-->
</section><!--end section-->
  <!--end section-->
  <div class="position-relative">
    <div class="shape overflow-hidden text-color-white">
      <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
      </svg>
    </div>
  </div>
  <!-- Hero End -->
  
  <section class="section">
    <div class="container">

        <div class="row align-items-center">
            <div class="col-lg-5 col-md-6 " *ngFor="let item of files">
              <img src="{{item.imageURL}}" class="img-fluid rounded shadow-md" alt="">
            </div>
            <!--end col-->
           
                    <div class="col-lg-7 col-md-6  mt-4 mt-sm-0 pt-2 pt-sm-0">
                        <div class="section-title me-lg-5">
                          <h4 class="title mb-4">{{modelObject.titleEn}} </h4>
                          <p class="text-muted">{{modelObject.descriptionEn}}.</p>
                        </div>
            </div>
          </div>
          <div class="row align-items-center">
            <div class="col-lg-12 mt-4 pt-2">
                <div class="card work-details rounded bg-light border-0">
                  <div class="card-body">
                    <h5 class="card-title border-bottom pb-3 mb-3">Requirements</h5>
                     <div class="faq-content mt-4 pt-2">
                       <ngb-accordion #acc="ngbAccordion" activeIds="ngb-panel-0" closeOthers="true" >
                         <ngb-panel cardClass="border-0 rounded shadow mb-2" *ngFor="let item of Requirement">
                           <ng-template ngbPanelTitle>
                             <div class="border-0 bg-light" id="headingtwo">
                               <h6 class="title mb-0">{{item.nameEn}}
                               </h6>
                             </div>
                           </ng-template>
                           <ng-template ngbPanelContent>
                             <p class="text-muted mb-0 faq-ans">{{item.descriptionEn}}.</p>
                           </ng-template>
                         </ngb-panel>
                       </ngb-accordion>
             
                     </div>
                   </div>
             </div>
            </div>
          </div>
    </div>
  </section>
  <!--end section-->
  
  <!-- Back to top -->
  <a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" [ngxScrollTo]="'#home'">
    <i-feather name="arrow-up" class="icons"></i-feather>
  </a>
  <!-- Back to top -->
